






































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _, { map } from 'lodash';
import moment from 'moment-timezone';
import { Spinner } from 'vue-image-spinner2';
import { validateStatusOrders } from '@/utils';
import MessageModal from '../modals/MessageModal.vue';
import { v4 as uuidv4 } from 'uuid';

@Component({
    name: 'messages',
    data: function () {
        return {
            messagesPage_: 1,
        };
    },
    components: {
        Spinner,
        MessageModal,
    },
    filters: {
        date(val) {
            return val == null ? 'Rango de fecha' : moment(val).format('YYYY/MM/DD');
        },
    },
    computed: {
        ...mapState('messages', [
            'recordMessagesLoading',
            'recordMessages',
            'pendingMessages',
            'pendingMessagesLoading',
            'invoiceMessages',
            'invoiceMessagesLoading',
            'messagesPerPage',
            'messagesPage',
            'messagesTotal',
        ]),
        ...mapState('auth', ['currentUser']),
        ...mapState('messages', {
            pendingMessages: (state: any) => {
                const pendingMessages = state.pendingMessages.map((message: any) => {
                    message.order_status = validateStatusOrders('Sinenvío', message.order_status);
                    return message;
                });
                // console.log();

                return pendingMessages;
                // return _.orderBy(pendingMessages, 'order_date', 'desc');
            },
        }),
        // validateStatusOrders(clearStatus, order.order_status);
    },
})
export default class Messages extends Vue {
    public pendingMessages!: any;
    public recordMessages!: any;
    public recordMessagesLoading!: any;
    public messagesType = false;
    public pendingMessagesLoading!: any;
    public messagesPerPage!: any;
    public messagesPage!: any;
    public messagesTotal!: any;
    private activeOrderLoaded: boolean = false;
    private activeFilters: boolean = false;
    public message_search: any = '';

    public messagesPage_!: any;
    public message_word_search: any = '';
    public logistic_type_filter: any = 'all';
    public messages_search: any = '';
    private currentUser!: any;

    logisticTypeOptions: any = [
        { value: 'all', text: 'Gestiones', disabled: true },
        { value: 'fulfillment', text: 'Fulfillment' },
        { value: 'drop_off', text: 'Regular' },
        { value: 'acordar', text: 'A acordar' },
        { value: 'cross_docking', text: 'M-E Colecta' },
    ];

    allOrdersHeaders = [{ thClass: 'th', key: 'id', label: 'Venta' }];
    allHeadersPending = [
        { thClass: 'th', key: 'sale', label: 'Venta' },
        { thClass: 'th', key: 'message', label: 'Pregunta' },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    fastAnswers = [
        { name: 'COTIZACION', data: 'El paquete con el material que nos solicita tendría un costo de' },
        { name: 'ENLACE', data: 'Le comparto el enlace, en la descripción específica lo que contiene la publicación' },
        {
            name: 'GRATIS',
            data: '¡Hola! gracias por ponerte en contacto con nosotros. Los envíos gratis son cálculos de mercado libre para sus clientes en productos nuevos desde $299',
        },
        {
            name: 'FULL',
            data: '¡Hola! gracias por ponerte en contacto con nosotros. Este producto es categoría "FULL" lo cual quiere decir que tu producto se encuentra en una bodega de Mercado Libre y ellos se encargan de que lo recibas en la fecha establecida. Para revisar fechas de recepción de producto y costo de envío haz clic debajo del precio de la publicación',
        },
        {
            name: 'ENVIOS',
            data: 'Hacemos envíos a todo el país. Si deseas saber el costo de tu envío o fecha estimada de entrega lo puedes corroborar debajo del precio en la publicación',
        },
        { name: 'SALUDO', data: '¡Hola! gracias por contactarnos' },
        {
            name: 'POLITICA',
            data: 'Lo sentimos, por políticas de mercado libre no podemos compartir o solicitar información personal o links fuera de este sitio en los comentarios de la publicación',
        },
        {
            name: 'FACTURA',
            data: 'Todos nuestros precios incluyen IVA y contamos con servicio de facturación. AVISO: La factura se realiza una vez entregado el producto (y que el cliente esté satisfecho con la recepción del mismo). A partir de que se recibe tienes 3 días hábiles para la solicitud de tu factura, los datos se envían por mensaje privado ya que las políticas de mercado libre prohíben compartir información personal en los comentarios de producto',
        },
        { name: 'GRACIAS', data: '¡Gracias por tu preferencia!, si requieres de factura puedes enviarnos un mensaje con tus datos' },
        {
            name: 'AVISO',
            data: 'AVISO: Estimados clientes, con motivo de las fiestas navideñas las facturas de las compras realizadas después del 23 de diciembre se estarán enviando en el mes de enero. Prodelec agradece su comprensión y les desea felices fiestas',
        },
        {
            name: 'NAVIDAD',
            data: '¡Hola, gracias por ponerte en contacto!, todas las series de navidad incluyen un regulador de luces para que ajustes el movimiento a tu preferencia y el enchufe está adaptado para añadir otra serie',
        },
        { name: 'SIN STOCK', data: 'Una disculpa, pero por el momento no contamos con existencia del producto' },
        {
            name: 'STOCK',
            data: 'Tenemos existencia, oferta sin problemas. Si deseas más de un producto puedes ajustar la cantidad cerca del botón de pago',
        },
        {
            name: 'CONECTANDO SOLUCIONES...',
            data: '¡Esperamos tu compra! Saludos Prodelec Mx Tienda Oficial',
        },
    ];

    public dateRange: any = {
        startDate: null,
        endDate: null,
    };
    public file_new: any = [];
    singleDatePicker: any = 'range';
    scrollContRecords: number = 0;
    busyRecords: boolean = false;
    pendingInterval: any = null;

    canSee(roles: any) {
        let roleValidation = false;
        let user1Id = '8c39c042-be3d-4e7c-9f54-a840d655fe14'; //montufar
        let user2Id = '69480895-26e4-4930-b376-b34efe3675ec'; //wendy
        let userdId = '69398834-1969-4dd8-bece-deff3c13404b'; //development
        switch (this.currentUser.role.name) {
            case 'Admin':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Developer':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'MercadoLibre Manager':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                if (this.currentUser.id != user1Id && this.currentUser.id != user2Id && this.currentUser.id != userdId) {
                    roleValidation = false;
                }
                break;
            default:
                roleValidation = false;
                break;
        }
        return roleValidation;
    }

    setUrlPage(page: any) {
        // @ts-ignore
        this.$router.push({
            path: 'messages',
            query: {
                ...this.$route.query,
                page,
            },
        });
        // this.messagesPage_ = page;
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'messages',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'desc' : 'asc',
            },
        });
    }

    setUrlSearch(search: string) {
        search = search.trim();
        this.$router.push({
            path: 'messages',
            query: {
                ...this.$route.query,
                search,
            },
        });
        this.$store.dispatch('messages/getOneOrder', { search, page: this.messagesPage_ });
    }

    downloadFile(file: any, store: string, order_id: string) {
        console.log('...');
        window.open(
            `https://www.mercadolibre.com.mx/api/messages/packs/${order_id}/sellers/430774329/messages/attachments/${file.filename}?siteId=MLM&tag=post_sale`,
            '_blank'
        );
    }

    clearFilters() {
        this.logistic_type_filter = 'all';
        this.message_word_search = '';
        this.$router.push({
            path: 'messages',
            query: {},
        });
        this.messagesPage_ = 1;
    }

    onOpenConversation(id: string) {
        // console.log('get conversation: ', id);

        this.$store.dispatch('messages/getOne', { id });
        // this.activeOrderLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('message-modal');
        }, 400);
    }

    onFilterClaimReturn(claimReturn: string) {
        // console.log({ claimReturn });
        this.$router.push({
            path: 'messages',
            query: {
                ...this.$route.query,
                claim_return_status_filter: claimReturn,
            },
        });
    }

    onFilterAssignedMove(assignedMove: string) {
        this.$router.push({
            path: 'messages',
            query: {
                ...this.$route.query,
                assigned_move_filter: assignedMove,
            },
        });
    }

    onFilterDateRange() {
        let start_date = moment(this.dateRange.startDate).format('YYYY/MM/DD');
        let end_date: any = moment(this.dateRange.endDate).add(1, 'd');
        end_date = moment(end_date).format('YYYY/MM/DD') + '';
        // console.log(start_date, '--', end_date);
        this.$router.push({
            path: 'messages',
            query: {
                ...this.$route.query,
                start_date: start_date,
                end_date: end_date,
            },
        });
    }

    @Watch('$route')
    getMessages() {
        if (this.$route.query.section == 'pending') {
            this.getPending(true);
        } else if(this.$route.query.section == 'invoice') {
            this.getInvoice(true);
        } else {
            this.getAllMessages();
        }
    }

    getPending(flag: boolean) {
        if (this.$route.query.section == 'history') {
            this.$router.push({
                path: 'messages',
                query: {
                    ...this.$route.query,
                    section: 'pending',
                    page: '1',
                },
            });
            this.messagesPage_ = 1;
        } else if(this.$route.query.section == 'invoice') {
            this.$router.push({
                path: 'messages',
                query: {
                    ...this.$route.query,
                    section: 'pending',
                    page: '1',
                },
            });
            this.messagesPage_ = 1;
        } else {
            this.$router.push({
                path: 'messages',
                query: {
                    ...this.$route.query,
                    section: 'pending',
                },
            });
        }
        let offset = 0;
        this.pendingMessages.length > this.messagesTotal ? (offset = 0) : (offset = this.pendingMessages.length);
        flag ? (offset = 0) : offset;

        let page = this.$route.query.page || 1;
        this.$store.dispatch('messages/getAllPending', { offset, page });
    }

    getInvoice(flag: boolean) {
        console.log(this.$route.query);
         if (this.$route.query.section == 'pending') {
            this.$router.push({
                path: 'messages',
                query: {
                    ...this.$route.query,
                    section: 'invoice',
                    page: '1',
                },
            });
            this.messagesPage_ = 1;
        } else if(this.$route.query.section == 'history') {
            this.$router.push({
                path: 'messages',
                query: {
                    ...this.$route.query,
                    section: 'invoice',
                    page: '1',
                },
            });
            this.messagesPage_ = 1;
        } else {
            this.$router.push({
                path: 'messages',
                query: {
                    ...this.$route.query,
                    section: 'invoice',
                },
            });
        }

        let offset = 0;
        this.pendingMessages.length > this.messagesTotal ? (offset = 0) : (offset = this.pendingMessages.length);
        flag ? (offset = 0) : offset;

        let page = this.$route.query.page || 1;
        this.$store.dispatch('messages/getAllInvoice', { offset, page });
        console.log(this.pendingMessages);
        

    
    }

    // getRecords() {
    //     this.scrollContRecords = 0;
    //     this.scrollContRecords = this.scrollContRecords + 3;
    //     // this.$store.dispatch('questions/pushRecords', { record: this.scrollContRecords, start_date: this.dateRange.start_date});
    //     this.$store.dispatch('messages/pushRecords', { record: this.scrollContRecords });
    //     this.messagesType = false;

    // }

    getAllMessages() {
        // @ts-ignore
        if (this.$route.query.section == 'pending') {
            this.$router.push({
                path: 'messages',
                query: {
                    ...this.$route.query,
                    section: 'history',
                    page: '1',
                },
            });
            this.messagesPage_ = 1;
        } else if(this.$route.query.section == 'invoice') {
            this.$router.push({
                path: 'messages',
                query: {
                    ...this.$route.query,
                    section: 'history',
                    page: '1',
                },
            });
            this.messagesPage_ = 1;
        } else {
            this.$router.push({
                path: 'messages',
                query: {
                    ...this.$route.query,
                    section: 'history',
                },
            });
        }

        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        const sortName = this.$route.query.sortName || null;
        const sortValue = this.$route.query.sortValue || null;
        const filterLogisticType = this.$route.query.filterLogisticType || null;
        const filterStatus = this.$route.query.filterStatus || null;
        const message_status_filter = this.$route.query.message_status_filter || null;
        const shipment_status_filter = this.$route.query.shipment_status_filter || null;
        const claim_return_status_filter = this.$route.query.claim_return_status_filter || null;
        const day_filter = this.$route.query.day_filter || null;
        const assigned_move_filter = this.$route.query.assigned_move_filter || null;
        const start_date = this.$route.query.start_date || null;
        const end_date = this.$route.query.end_date || null;
        this.$store.dispatch('messages/getAll', {
            page,
            search,
            sortName,
            sortValue,
            filterLogisticType,
            filterStatus,
            message_status_filter,
            shipment_status_filter,
            claim_return_status_filter,
            day_filter,
            assigned_move_filter,
            start_date,
            end_date,
        });
    }

    onSendMessages(id: any, message: any, store: any, client_id: any) {
        let file = this.file_new;
        let updated_by = this.currentUser.first_name + ' ' + this.currentUser.last_name;
        let payload = { id, message, store, updated_by, client_id, file };

        if (message !== undefined || file.length > 0) {
            this.$store.dispatch('messages/postMessage', payload);
        } else {
            this.$bvToast.toast('No se ha ingresado mensaje o archivo.', {
                title: `Mensaje no enviado`,
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
            return false;
        }
    }

    onFileChange(e: any) {
        let sendFile = [];
        if (e.target) {
            const file = e.target.files[0];
            let mega = 1024 * 1024;
            let megas25 = mega * 25;
            console.log(mega, megas25, file.size);

            if (file.size <= megas25) {
                let formData = new FormData();
                formData.append('file', file, file.name);
                sendFile = [
                    {
                        id: uuidv4(),
                        url: URL.createObjectURL(file),
                        origin: 'upload',
                        file: formData,
                        archivo: file,
                        name: file.name,
                        size: file.size,
                    },
                ];
                // this.file_new = formData;
                this.file_new = sendFile;
            } else {
                this.$bvToast.toast(`Error al cargar el archivo ${file.name}.`, {
                    title: `Tamaño máximo 25M`,
                    variant: 'warning',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            }
        }
    }

    mounted() {
        this.getPending(true);
        this.messagesPage_ = 1;
        this.$router.push({
            path: 'messages',
            query: {
                ...this.$route.query,
                section: 'pending',
            },
        });
    }
}
